import NBType, { InferType } from '@netbase/nb-type'
import ChannelLevel from '../enums/ChannelLevel'
import SocialWebChannelType from '../enums/SocialWebChannelType'

const SocialWebChannelSchema = NBType.object().shape('SocialWebChannelSchema', {
  /* @prop */
  channelId: NBType.string().nullable(),
  /* @prop */
  inputValue: NBType.string(),
  /* @prop */
  level: NBType.enum(ChannelLevel).nullable(),
  /* @prop */
  name: NBType.string(),
  /* @prop */
  progress: NBType.number().nullable(),
  /* @prop */
  type: NBType.enum(SocialWebChannelType)
  /* END */
})
export default SocialWebChannelSchema
export type SocialWebChannel = InferType<typeof SocialWebChannelSchema>
// RESERVE BELOW
